function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  className: "dashboard-hi-dark_svg__st0",
  cx: 96,
  cy: 96,
  r: 80,
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "dashboard-hi-dark_svg__st1",
  d: "M176 95v1c0 44.2-35.8 80-80 80s-80-35.8-80-80v-1c.5 43.8 36.2 79 80 79s79.5-35.2 80-79z",
  opacity: 0.06
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "dashboard-hi-dark_svg__st2",
  d: "M96 54.5c-1.1 0-2-.9-2-2v-17c0-1.1.9-2 2-2s2 .9 2 2v17c0 1.1-.9 2-2 2zM52.4 98h-17c-1.1 0-2-.9-2-2s.9-2 2-2h17c1.1 0 2 .9 2 2s-.9 2-2 2zM156.4 98h-17c-1.1 0-2-.9-2-2s.9-2 2-2h17c1.1 0 2 .9 2 2s-.9 2-2 2zM65.1 67.3c-.5 0-1-.2-1.4-.6l-12-12c-.8-.8-.8-2 0-2.8.8-.8 2-.8 2.8 0l12 12c.8.8.8 2 0 2.8-.4.4-.9.6-1.4.6z",
  fill: "#4a4d4e"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M96 80c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16m18 16c0 9.9-8.1 18-18 18s-18-8.1-18-18 8.1-18 18-18 18 8.1 18 18z",
  opacity: 0.06
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "dashboard-hi-dark_svg__st4",
  d: "M138.4 53.1l37.4 37c.1 1.9.2 3.9.2 5.9 0 25.2-11.8 48.9-32 64l-56.9-56 51.3-50.9z",
  opacity: 0.2
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  className: "dashboard-hi-dark_svg__st5",
  cx: 96,
  cy: 96,
  r: 12,
  fill: "#e60000"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "dashboard-hi-dark_svg__st5",
  d: "M104.7 92c-1.1 0-2.2-.4-3-1.2-1.6-1.6-1.6-4.3 0-6L133 53.5c1.6-1.6 4.3-1.6 6 0 1.6 1.6 1.6 4.3 0 6l-31.3 31.3c-.8.8-1.9 1.2-3 1.2z",
  fill: "#e60000"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "dashboard-hi-dark_svg__st6",
  d: "M140.1 55.5c.4 1.4-.1 3-1.1 4l-31.3 31.3-.1.1c-.1-.5-.3-1.1-.5-1.6.2-.2.5-.3.7-.5L139 57.5c.5-.6.9-1.3 1.1-2z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "dashboard-hi-dark_svg__st6",
  d: "M107.9 95c.1.3.1.7.1 1 0 6.6-5.4 12-12 12s-12-5.4-12-12c0-.3.1-.7.1-1 .5 6.2 5.7 11 11.9 11s11.4-4.8 11.9-11z",
  opacity: 0.12
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "dashboard-hi-dark_svg__st7",
  fill: "none",
  d: "M0 0h192v192H0z"
});

var SvgDashboardHiDark = function SvgDashboardHiDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

export default SvgDashboardHiDark;